<template>
  <section class="login-form">
    <div class="container-fluid" v-if="!isSuccess && !newPassword">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-form-img">
            <img :src="otpImg" alt="login form img" />
          </div>
        </div>

        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-form-inputs">
            <a
              v-if="!objOtp.isLoginPage"
              href="javascript:void(0)"
              class="back-btn"
              @click="emitToParent()"
            >
              <img src="../../../Assets/Images/arrow-left.png" alt="arrow" />
              <span>{{ objOtp.backBtn }}</span>
            </a>
            <a
              v-if="objOtp.isLoginPage"
              href="javascript:void(0)"
              class="back-btn"
              @click="backLogin()"
            >
              <img src="../../../Assets/Images/arrow-left.png" alt="arrow" />
              <span>{{ objOtp.backBtn }}</span>
            </a>
            <div class="login-form-logo">
              <img src="../../../Assets/Images/logo-login.png" alt="Eda logo" />
            </div>
            <h3 class="generic-description">{{ objOtp.OTPTitle }}</h3>
            <p class="input-ask">{{ objOtp.OTPConfirmEmail }}</p>
            <form v-on:submit.prevent="onSubmit" class="form-container">
              <div class="input-field">
                <input
                  type="text"
                  :placeholder="objOtp.OTPVerifyCode"
                  v-model.trim="formData.UserOTP"
                />
                <p>
                  <span class="form-container__error-msg" v-if="OtpRequired">{{
                    objOtp.OTPVerifyCodeRequired
                  }}</span>
                  <span class="form-container__error-msg" v-if="OtpNotValid">{{
                    objOtp.OTPVerifyCodeNotValid
                  }}</span>
                </p>
              </div>
              <button
                v-if="!objOtp.isForgetPasswordPage"
                @click.prevent="onSubmit"
                type="submit"
                class="custom-btn"
              >
                {{ objOtp.submit }}
              </button>
              <button
                v-if="objOtp.isForgetPasswordPage"
                @click.prevent="onSubmitPassword"
                type="submit"
                class="custom-btn"
              >
                {{ objOtp.submit }}
              </button>
              <div class="news-letter__loader" v-if="isLoading">
                <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--v-on:childToParent="onChildClick"-->
    <new-password-component
      v-if="newPassword && !isSuccess"
      :objOtp="objOtp"
      v-on:password="passPassword"
      v-on:backBtn="backToOtp"
    ></new-password-component>

    <div class="container-fluid" v-if="isSuccess">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-form-img">
            <img :src="otpImg" alt="login form img" />
          </div>
        </div>

        <div class="col-lg-6 col-md-12 col-sm-12">
            <div class="success-block">
                <div class="login-form-logo">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         id="check"
                         width="144"
                         height="144"
                         viewBox="0 0 144 144">
                        <defs></defs>
                        <g id="Group_1310">
                            <g id="Group_1309">
                                <path id="Path_6591"
                                      d="M72 0a72 72 0 1 0 72 72A72 72 0 0 0 72 0zm0 139.355A67.355 67.355 0 1 1 139.355 72 67.355 67.355 0 0 1 72 139.355z"
                                      class="cls-1" />
                                <path id="Path_6592"
                                      d="M187.073 156.75l-47.132 47.132-23.906-23.906a2.323 2.323 0 0 0-3.284 3.284l25.549 25.549a2.323 2.323 0 0 0 3.284 0l48.774-48.774a2.323 2.323 0 0 0-3.284-3.284z"
                                      class="cls-1"
                                      transform="translate(-79.554 -110.78)" />
                            </g>
                        </g>
                    </svg>
                </div>
                <h3 class="generic-description" v-if="objOtp.isForgetPasswordPage">{{ objOtp.passwordSuccess }}</h3>
                <h3 class="generic-description" v-if="objOtp.isLoginPage">{{ objOtp.registeredSuccess }}</h3>
                <h3 class="generic-description" v-if="objOtp.isRegister">{{ objOtp.registeredSuccess }}</h3>
                <div class="success-screen-btns">
                    <a href="/" class="custom-btn"> {{ objOtp.home }} </a>
                    <a :href="objOtp.loginUrl" class="custom-btn">
                        {{ objOtp.login }}
                    </a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import newPasswordComponent from "../NewPassword/NewPassword.vue";

let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";

export default {
  props: {
    signIn: {
      type: String,
    },
    objOtp: {
      type: Object,
    },
  },
  data() {
    return {
      otpImg: this.objOtp.imgDesktop,
      isSuccess: false,
      newPassword: false,
      isLoading: false,
      OtpNotValid: false,
      OtpRequired: false,
      formData: {
        Email: "",
        UserOTP: "",
      },
    };
  },
  components: {
    newPasswordComponent,
  },
  methods: {
    onSubmit() {
      if (this.formData.UserOTP != "") {
        this.isLoading = true;
        let headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        let formObj = {
            Email: this.objOtp.userEmail,
            UserOTP: this.formData.UserOTP,
            EdaID: this.objOtp.EdaID
        };

        axios
          .post(`${apiUrl}/Umbraco/Surface/Users/ValidateOTP`, formObj, headers)
          .then((res) => {
            this.isLoading = false;
            if (res.data == true) {
              this.isSuccess = true;
            } else {
              this.OtpNotValid = true;
              this.OtpRequired = false;
            }
          })
          .catch(() => {
          });
      } else {
        this.OtpRequired = true;
        this.OtpNotValid = false;
      }
    },
    onSubmitPassword() {
      if (this.formData.UserOTP != "") {
        this.isLoading = true;
        let headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        let formObj = {
          Email: this.objOtp.userEmail,
          UserOTP: this.formData.UserOTP,
        };

        axios
          .post(
            `${apiUrl}/Umbraco/Surface/Users/ValidateOTPPassword`,
            formObj,
            headers
          )
          .then((res) => {
            this.isLoading = false;
            if (res.data == true) {
              this.newPassword = true;
            } else {
              this.OtpNotValid = true;
              this.OtpRequired = false;
            }
          })
          .catch(() => {
          });
      } else {
        this.OtpRequired = true;
        this.OtpNotValid = false;
      }
    },
    passPassword(value) {
        if (value) {
            this.newPassword = false;
            this.isSuccess = true;
        }
    },
    backToOtp(value) {
        if (value) {
            this.newPassword = false;
            this.isSuccess = false;
        }
    },
    emitToParent() {
      this.$emit("childToParent", true);
    },
    backLogin() {
    this.$emit("childToParent", false);
    },
  },
    mounted() {
        if (window.innerWidth <= 768) {
            this.otpImg = this.objOtp.imgMobile;
        } else {
            this.otpImg = this.objOtp.imgDesktop;
        }
    if (document.querySelector(".navbar.navbar-expand-lg")) {
      document.querySelector(".navbar.navbar-expand-lg").style.display = "none";
      document.querySelector(".breadcrumb-container").style.display = "none";
      if (document.querySelector(".generic-banner")) {
        document.querySelector(".generic-banner").style.display = "none";
      }
      document.querySelector(".footer").style.display = "none";
      if (document.querySelector(".register-form-container")) {
        document.querySelector(".register-form-container").style.display =
          "none";
      }
      document.querySelector(".copy-right").style.display = "none";
    }
  },
};
</script>
